import i18n from '@/main';

const regras = {
    idEstado: [
        {
            required: true,
            message: i18n.t('configuracaoParametros.erro.campoEstadoErro'),
            trigger: 'change'
        }
    ],
    distanciaRaioKm: [
        {
            required: true,
            message: i18n.t('configuracaoParametros.erro.campoDisRKmErro'),
            trigger: 'blur'
        }
    ]
};

export default regras;
